import { useEffect, useState } from "react";
import Header from "../components/Header";
import axios from "@/shared/config/axios-interceptor";
import { formatMoney } from "@/shared/utils/ultils";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const LichSuNapTien = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const [listData, setListData] = useState<any>([]);
  const getData = async () => {
    try {
      const res = await axios.get("/transaction/chi-tiet-kinh-phi?limit=50");
      setListData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const renderType = (type: number) => {
    switch (type) {
      case 1:
        return <span>{t("Thu nhập")}</span>;
      case 2:
        return <span>{t("Chi phí")}</span>;
      case 3:
        return <span>{t("Gửi tiết kiệm")}</span>;
      case 4:
        return <span>{t("Phát sinh lợi nhuận")}</span>;
      case 5:
        return <span>{t("Thưởng")}</span>;
      default:
        return <span>{t("Nạp")}</span>;
    }
  };

  const renderStatus = (status: number, type: number) => {
    if (type != 2) return <span>{t("Nạp tiền thành công")}</span>;
    switch (status) {
      case 0:
        return <span>{t("Đang xử lý")}</span>;
      case 1:
        return <span>{t("Rút tiền thành công")}</span>;
      case 2:
        return <span>{t("Rút tiền thất bại")}</span>;
      default:
        return <span>{t("Đang xử lý")}</span>;
    }
  };
  return (
    <div className="wrapper">
      <div className="container-web gioithieusanpham bgnew">
        <Header title={t("Lịch sử giao dịch")} />

        <main style={{ fontSize: 12 }}>
          {listData?.length == 0 && (
            <div className="p-5 text-center" style={{ fontSize: 14 }}>
              {t("Không có dữ liệu")}
            </div>
          )}
          {listData?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="px-3 py-2"
                style={{ borderBottom: "1px solid #333" }}
              >
                <div className="d-flex justify-content-between fw-bold">
                  <span>{renderType(item.type)}</span>
                  <span style={{ color: "#d5b377" }}>
                    {formatMoney(item.money)}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>
                    {dayjs(item.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                  </span>
                  <span>{renderStatus(item.status, item.type)}</span>
                </div>
              </div>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default LichSuNapTien;
